import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { ConnectivityService } from '../services/connectivity.service';

export const connectivityInterceptor: HttpInterceptorFn = (req, next) => {
  const connectivity = inject(ConnectivityService);

  return next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse) connectivity.setOnline();
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 0) connectivity.setOffline();
      return throwError(() => error);
    })
  );
};
